export default __webpack_public_path__ + "static/media/team_4.053ec8cc.jpg";